import { render } from "./arenaRecord.vue?vue&type=template&id=1e30612d&scoped=true"
import script from "./arenaRecord.vue?vue&type=script&lang=js"
export * from "./arenaRecord.vue?vue&type=script&lang=js"

import "./arenaRecord.vue?vue&type=style&index=0&id=1e30612d&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e30612d"]])

export default __exports__